import { ISemanticEvent, Integration } from '@cp/shared/tracking';
import { IntegrationFactory } from './factory';

export type DataLayerConfig = {
  dataLayerName?: string;
  defaultCurrency?: string;
  preferId?: boolean;
  useTranslit?: boolean;
};
const DEFAULT_OPTIONS = {
  dataLayerName: 'dataLayer',
  preferId: false,
  useTranslit: false,
};

export class DataLayer implements Integration {
  private dataLayer: { push(data: any): void };
  private readonly options: DataLayerConfig & typeof DEFAULT_OPTIONS;

  constructor(
    config: DataLayerConfig,
    private readonly global: any,
  ) {
    this.options = Object.assign({}, DEFAULT_OPTIONS, config);
    this.dataLayer = this.init();
  }

  private init() {
    return this.global[this.options.dataLayerName] || (this.global[this.options.dataLayerName] = []);
  }

  get displayName() {
    return 'DataLayer';
  }

  trackEvent(event: ISemanticEvent) {
    this.dataLayer.push({ event: event.name, gtm: event.payload });
  }
}

export const createDatalayer: IntegrationFactory = (_, global) => Promise.resolve(new DataLayer({ defaultCurrency: 'RUB' }, global));
